import React, { useEffect, useState } from 'react';
import Socials from './Socials';

/* eslint-disable no-unused-vars */


const HelloHero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [secondIsVisible, setsecondIsVisible] = useState(false);
  const [showFirstElement, setShowFirstElement] = useState(true);
  const [showSecondElement, setShowSecondElement] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFirstElement(false);
      setShowSecondElement(true);
    }, 1500);

    const visbility = setTimeout(() => {
      setIsVisible(true);
    }, 300);

    const secondvisbility = () => {
      setsecondIsVisible(true);
    };

    return () => clearTimeout(timer, visbility, secondvisbility);
  }, []);

  return (
    <section className="hero-intro">
      <div className="name-job-div">
        <div>
          {showFirstElement && <p className={`hello fade-in ${isVisible ? 'visible' : ''}`}>Hi!</p>}
          {showSecondElement && (
            <div className={`about-my-portfolio ${secondIsVisible ? 'fade-in-about' : ''}`}>
              <p className="description">I am <span  className='name-style' style={{color: 'rgb(9, 229, 9)',}}>Racheal </span>. I create</p>
              <p className="description">interactive websites that</p>
              <p className="description">leverage AI and ML</p>
              <p>
                {' '}
                <u>Full Stack</u>
                {' '}
                Developer
              </p>
              <a
                className="downloadCV"
                href="https://drive.google.com/file/d/10iCBraPWEHUGrreD6xZta-ljUewnDWhu/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                View CV
              </a>
            </div>
          )}
        </div>
      </div>
      <Socials />
    </section>
  );
};

export default HelloHero;
